import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { CoolerFan } from '../model/CoolerFan';
import { Gabinete } from '../model/Gabinete';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_GabineteCoolerFan extends FuncionCompatilibidadBase<Gabinete, CoolerFan> {
  funciones = {
    dimensiones: (gabinete: Gabinete, coolerFan: CoolerFan): Incompatibilities | null => {
      return !gabinete.$caracteristicas[`cf_${coolerFan.$caracteristicas.dimensiones}mm`] ?
          {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: 'El gabinete no es compatible con este producto',
          }
        : null;
    },
  };
}
